export default __webpack_public_path__ + "static/media/ip-mon.56ecd866.svg";